<div class="message-list-container">
  <div class="message-list-header">
    <div class="header-controls">
      <ix-input
        class="filter-field"
        ixTest="websocket-debug-filter"
        [placeholder]="'Filter by method' | translate"
        [(ngModel)]="filterText"
        (ngModelChange)="applyFilter()">
      </ix-input>
      <mat-checkbox
        ixTest="websocket-debug-auto-scroll"
        matTooltip="Auto-scroll to latest message"
        [(ngModel)]="autoScroll">
        Auto-scroll
      </mat-checkbox>
      <mat-checkbox
        ixTest="websocket-debug-duplicate-notifications"
        matTooltip="Show snackbar when duplicate API calls are detected"
        [checked]="duplicateNotificationsEnabled$ | async"
        (change)="toggleDuplicateNotifications()">
        Duplicate alerts
      </mat-checkbox>
      <tn-icon-button
        name="delete-outline"
        library="mdi"
        tooltip="Clear messages"
        class="clear-button"
        ixTest="websocket-debug-clear-messages"
        (click)="clearMessages()"
      ></tn-icon-button>
    </div>
  </div>

  @if (!hasMessages) {
    <div class="empty-state">
      <tn-icon name="message-text-outline" library="mdi" class="empty-icon"></tn-icon>
      <p>No messages yet</p>
    </div>
  } @else {
    <div #messageViewport class="message-viewport">
      @for (message of filteredMessagesArray; track message.id) {
        <div class="message-item"
             [class.outgoing]="message.direction === 'out'"
             [class.incoming]="message.direction === 'in'"
             [class.mocked]="message.isMocked"
             [class.expanded]="message.isExpanded">
          
          <div class="message-header">
          <span class="direction-icon">
            @if (message.direction === 'out') {
              <tn-icon name="arrow-right" library="mdi" class="icon-out"></tn-icon>
            } @else {
              <tn-icon name="arrow-left" library="mdi" class="icon-in"></tn-icon>
            }
          </span>
          
          <span class="method-name">{{ message.methodName }}</span>
          
          @if (message.isMocked) {
            <span class="mocked-badge">MOCKED</span>
          }
          
          <span class="timestamp">{{ message.formattedTime }}</span>
          
          @if (canCreateMock(message)) {
            <tn-icon-button
              name="plus"
              library="mdi"
              tooltip="Create mock from response"
              class="mock-button"
              ixTest="websocket-debug-create-mock"
              [attr.aria-label]="'Create mock from response'"
              (click)="createMockFromMessage(message); $event.stopPropagation()"
            ></tn-icon-button>
          }

          <tn-icon-button
            name="content-copy"
            library="mdi"
            tooltip="Copy message"
            class="copy-button"
            ixTest="websocket-debug-copy-message"
            [attr.aria-label]="'Copy message'"
            (click)="copyMessage(message); $event.stopPropagation()"
          ></tn-icon-button>

          <tn-icon-button
            library="mdi"
            class="toggle-button"
            ixTest="websocket-debug-toggle-message"
            tooltip="Toggle message details"
            [name]="message.isExpanded ? 'chevron-down' : 'chevron-right'"
            [attr.aria-label]="message.isExpanded ? 'Collapse message details' : 'Expand message details'"
            [attr.aria-expanded]="message.isExpanded"
            (click)="toggleMessage(message.id)"
          ></tn-icon-button>
        </div>
        
        @if (!message.isExpanded) {
          <div class="message-preview">
            {{ message.messagePreview }}
          </div>
        }
        
        @if (message.isExpanded) {
          <div class="message-expanded">
            <pre>{{ message.message | json }}</pre>
          </div>
        }
      </div>
      }
    </div>
  }
</div>